import React from 'react';
import { StateSetterFunction } from '@repo/ui/src/types/helpers';

export const useDerivedState = <T>(value: T): [T, StateSetterFunction<T>] => {
  const ref = React.useRef<T>();
  const [state, setState] = React.useState(value);

  React.useEffect(() => {
    setState(value);
    ref.current = value;
  }, [value, ref]);

  return [ref.current === value ? state : value, setState];
};
